/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export abstract class AuthService {
  abstract useWithCredentials(): boolean;
  abstract getToken(): string | null;
  abstract isExpired(): boolean;
  abstract initialize(): Promise<boolean>;
  abstract refreshToken(): Promise<void>;
  abstract login(redirect?: string): Promise<void>;
  abstract logout(redirect?: string): Promise<void>;
  abstract toJSON(): string;
  protected clear(): void {
    window.localStorage.removeItem('offline');
  }
}
